<template>
  <div
    v-show="showCms ? state.modelValue === val : !isDisabled"
    :id="'panel-' + val"
    class="ui-parts-tab-panel"
    :aria-expanded="state.modelValue === val"
    :aria-hidden="state.modelValue !== val"
    role="tabpanel"
  >
    <slot />
  </div>
</template>

<script lang="ts" setup>
import type { TabPanelsState } from './BaseTab.vue'

interface Props {
  val: string
  showCms?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  showCms: false,
})

const state: TabPanelsState = inject('tab-state')

const isDisabled = computed(() => {
  const opt = state.tabOptions.filter(opt => opt.val === props.val).pop()
  return opt && opt.disabled
})
</script>

<style lang="scss" scoped>
.ui-parts-tab-panel {
  width: 100%;
  display: inline-block;
  white-space: initial;
  vertical-align: top;
}
</style>
